import axios from 'axios';

// N-100 (расширено на doctor-cabinet): токен живёт 7 дней (ACCESS_TOKEN_EXPIRE_MINUTES),
// но не на всех страницах есть свой .catch(), который чистит localStorage и редиректит на
// /login при истечении (см. Support.js — тикеты грузились без .catch() вовсе, страница
// вечно висела на "Загрузка…", тот же баг, что нашли в админке). Единая точка обработки.
//
// Редиректим ТОЛЬКО если токен реально был выставлен — иначе публичные страницы
// (/login, /register, /forgot-password и т.п.) ложно словили бы, например, 401
// "неверный пароль" как истёкшую сессию.
const TOKEN_KEY = 'token';

// N-125: сессия импersonации (см. AdminSession.js) живёт в sessionStorage — она НЕ
// шарится между вкладками одного origin (в отличие от localStorage). Без этого перехватчика
// AdminSession.js писал бы токен в общий localStorage и молча подменял бы реальную сессию
// врача, если у него в этом же браузере уже была открыта своя вкладка кабинета (нашёл
// пользователь: баннер администратора появился в чужой, обычной вкладке). Перехватчик
// подставляет sessionStorage-токен ПРИОРИТЕТНО перед localStorage на каждый запрос — так
// вкладка с impersonation не трогает чужую сессию, даже если инлайн-код страницы читает
// localStorage напрямую при формировании заголовков.
axios.interceptors.request.use((config) => {
  const t = sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = 'Bearer ' + t;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (sessionStorage.getItem(TOKEN_KEY)) {
        sessionStorage.clear();
        if (window.location.pathname !== '/login') window.location.href = '/login';
      } else if (localStorage.getItem(TOKEN_KEY)) {
        localStorage.clear();
        if (window.location.pathname !== '/login') window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
